import { BoxProps } from 'shared/mui/Box';

import { ActionsStyled, WrapperStyled } from './FilterDrawerActionsButtons.styled';

export type FilterActionsButtonsProps = {
  fullWidth?: boolean;
  topSlot?: React.ReactNode;
} & BoxProps;

export const FilterDrawerActionsButtons: React.FC<FilterActionsButtonsProps> = ({
  children,
  fullWidth,
  topSlot,
  ...restProps
}) => {
  return (
    <WrapperStyled {...restProps}>
      {topSlot}
      <ActionsStyled fullWidth={fullWidth}>{children}</ActionsStyled>
    </WrapperStyled>
  );
};
